export const cloneConfigModal = {
  close: "Close",
  searchPlaceholder: "Search listing…",
  clearSearch: "Clear",
  bar: {
    chooseSource: "Choose the source listing",
    selected: "{count} selected | {count} selected",
    selectAll: "Select all",
    clear: "Clear",
  },
  list: {
    loading: "Loading listings…",
    empty: "No listings match your search.",
    unitsBadge: "{count} units",
  },
  confirm: {
    sourceLabel: "Chosen source",
    applyToLabel: "Will apply to",
    andItsUnits: "(and its {count} units)",
    andMore: "and {count} more",
    undoWarning: "This action can't be undone.",
  },
  footer: {
    back: "Back",
    cancel: "Cancel",
    continue: "Continue",
  },
  preview: {
    unit: "Unit",
    listing: "Listing",
    empty: "Not set up.",
    loading: "Loading…",
  },
  confirmTitle: {
    pull: "Confirm before bringing",
    push: "Review before copying",
  },
  confirmLabel: {
    pulling: "Bringing…",
    copying: "Copying…",
    confirmPull: "Yes, bring settings",
    confirmPush: "Yes, copy to {count} listing | Yes, copy to {count} listings",
  },
  intro: {
    pullLead: "You're about to bring {noun} from the listing you chose.",
    pullReplace: "It will replace what you have here now.",
    pullAdd: "It will be added to what you already have here.",
    pushLead: "You're about to copy {noun} to {count} listing. | You're about to copy {noun} to {count} listings.",
    pushReplace: "It will replace what it has now{scope}. | It will replace what they have now{scope}.",
    pushAdd: "It will be added to what it already has. | It will be added to what they already have.",
    pushScope: ", including the sending settings",
  },
  attachments: {
    fileFallback: "Attachment",
    titleAlsoCopied: "Attachments are copied too",
    titlePullLose: "You'll lose the attachments you have now",
    titlePullGain: "Its attachments will come over too",
    titlePushEmpty: "The chosen listings will be left with no attachments",
    noteUnknownPull: "The attachments from the listing you chose will replace the ones here, which will be deleted.",
    noteUnknownPush: "The attachments from this listing will replace the ones on the chosen listings, which will be deleted.",
    notePullReplace: "They'll be deleted and replaced by the ones from the listing you chose.",
    notePullEmpty: "There are no attachments here right now, so you lose nothing: the ones from the chosen listing will come over.",
    notePushEmpty: "This listing has no attachments, so the ones on the chosen listing will be deleted and it will be left with none. | This listing has no attachments, so the ones on the chosen listings will be deleted and they will be left with none.",
    notePushReplace: "They'll be copied to the chosen listing and replace its own, which will be deleted. | They'll be copied to the chosen listings and replace their own, which will be deleted.",
  },
  toast: {
    loadError: "Couldn't load the listings",
    pullSuccess: "Settings brought successfully",
    pushSuccess: "Settings copied to {count} listing | Settings copied to {count} listings",
    pullError: "Couldn't bring the settings",
    pushError: "Couldn't copy the settings",
  },
};
